<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :isDashboardView='false'
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div id="familyHeaderDiv">
                <h2>{{ activity }}</h2>

                <div id="parentInfo">
                    <ul>
                        <li><strong>Bill-To:</strong> {{ billTo }}</li>
                        <li><strong>Company:</strong> {{ company }}</li>
                        <li><strong>Created At:</strong> {{ createdAt }}</li>
                        <li><strong>Created By:</strong> {{ createdBy }}</li>
                        <li v-if="submittedAt"><strong>Submitted At:</strong> {{ submittedAt }}</li>
                        <li><strong>Price Auth:</strong> {{ priceAuth }}</li>
                    </ul>
                </div>
            </div>
            <br>
            <div v-if="submission.canBeSubmitted || priceDeviationAdmins.includes(user.id)" id="parentActions">
                <h3>Parent Actions</h3>
                <div v-if="submission.canBeSubmitted" class="iconContainer">
                    <button type="button" class="iconButton" @click="submitEntry(submission.id)">
                        <img class="iconImg" src="/images/icon-circle-submit.png" alt="Submit family" />
                    </button>
                    <p class="iconLabel">SUBMIT FAMILY</p>
                </div>
                <div v-if="submission.canBeExported && priceDeviationAdmins.includes(user.id)" class="iconContainer">
                    <button type="button" class="iconButton" @click="openExportModal(submission.id)">
                        <img class="iconImg" src="/images/icon-circle-download.png" alt="Download Family Export" />
                    </button>
                    <p class="iconLabel">EXPORT FAMILY</p>
                </div>
                <div v-if="submission.canBeSubmitted || priceDeviationAdmins.includes(user.id)" class="iconContainer">
                    <button @click="deleteEntry(submission.id, 'family')" type="button" class="iconButton">
                        <img class="iconImg" src="/images/icon-circle-trash.png" alt="Delete Family" />
                    </button>
                    <p class="iconLabel">DELETE FAMILY</p>
                </div>
                <div v-if="executingAction" class="iconContainer">
                    <vue-loaders-ball-beat scale="1" color="black" />
                </div>
            </div>
            <br>
            <div id="childrenDiv">
                <table id="childrenTable">
                    <thead>
                        <tr>
                            <th v-if="displayFamilyBulkColumn">Bulk</th>
                            <th>Status</th>
                            <th>Style</th>
                            <th>SKUs</th>
                            <th>Suggested Price</th>
                            <th>VAR %</th>
                            <th v-if="displayFamilyBulkColumn">Approval Level</th>
                            <th>Rationale</th>
                            <th>Proj Sales</th>
                            <th>Eff Date</th>
                            <th colspan="3">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="child in submission.child_submissions">
                            <tr>
                                <td v-if="displayFamilyBulkColumn">
                                    <input
                                        type="checkbox"
                                        :value="child.id"
                                        v-model="selectedChildIds"
                                        :disabled="!canChildCheckboxBeEnabled(child)"
                                    />
                                </td>
                                <td>{{ child.statusString }}</td>
                                <td>
                                    <img v-if="child.tariff_flag" src="/images/price-workflow/icon-alert.gif" style="position:relative; height:1rem; width:auto;">
                                    {{ child.prod_key }}
                                </td>
                                <td v-html="child.skuList.join('<br>')"></td>
                                <td>${{ child.sug_price }} ({{ child.uom }})</td>
                                <td>{{ child.sug_var }}%</td>
                                <td v-if="displayFamilyBulkColumn">{{ child.currentStep }}</td>
                                <td>{{ child.rationale }}</td>
                                <td>{{ child.proj_sales }}</td>
                                <td>{{ child.eff_date }}</td>
                                <td v-if="child.pp_status === 'n'" class="iconTd">
                                    &nbsp;
                                </td>
                                <td v-else class="iconTd">
                                    <router-link :to="{ name: 'PriceWorkflowSignoff', params: { ppId: child.id } }">
                                        <img class="iconImg" src="/images/icon-circle-view-green.png" alt="View child submission" />
                                    </router-link>
                                    <p class="iconLabel">VIEW</p>
                                </td>
                                <td v-if="child.pp_status === 'n' || child.pp_status === 'd'" class="iconTd">
                                    <router-link :to="{ 
                                            name: 'PriceWorkflowSkuSelect', 
                                            params: {ppId: child.id},
                                            query: { editing: 'true' }
                                        }"
                                    >
                                        <img class="iconImg" src="/images/icon-circle-edit.png" alt="Edit child submission" />
                                    </router-link>
                                    <p class="iconLabel">EDIT</p>
                                </td>
                                <td v-else-if="child.canBeExported && priceDeviationAdmins.includes(user.id)" class="iconTd">
                                    <button type="button" class="iconButton" @click="openExportModal(child.id)">
                                        <img class="iconImg" src="/images/icon-circle-download.png" alt="Download child submission" />
                                    </button>
                                    <p class="iconLabel">EXPORT</p>
                                </td>
                                <td v-else class="iconTd">
                                    &nbsp;
                                </td>
                                <td v-if="child.pp_status === 'n' || priceDeviationAdmins.includes(user.id)" class="iconTd">
                                    <button @click="deleteEntry(child.id, 'child')" type="button" class="iconButton">
                                        <img class="iconImg" src="/images/icon-circle-trash.png" alt="Delete child submission" />
                                    </button>
                                    <p class="iconLabel">DELETE</p>
                                </td>
                                <td v-else class="iconTd">
                                    &nbsp;
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div v-if="displayFamilyBulkColumn" style="margin-top: 15px;">
                <div id="bulkActionBar">
                    <div class="bulkItem bulkSelectItem">
                        <input
                            type="checkbox"
                            id="selectAllCheckbox"
                            :checked="allEligibleChildrenSelected"
                            @change="toggleSelectAll"
                        /> SELECT ALL
                    </div>

                    <div class="bulkItem bulkTextItem">
                        <span><strong>BULK ACTIONS:</strong></span>
                    </div>

                    <div class="bulkItem" v-if="hasChildrenInProgress">
                        <button @click="selectAllInProgress" type="button" class="btn-round-red" style="margin-top:0;">
                            Select All In-Progress
                        </button>
                    </div>

                    <div class="bulkItem" v-if="hasChildrenInProgress">
                        <button
                            @click="triggerBulkAction('bulkApprove', 'a')"
                            type="button"
                            class="btn-round-green"
                            style="margin-top:0;"
                        >
                            Approve
                        </button>
                    </div>

                    <div class="bulkItem" v-if="hasChildrenApproved">
                        <button @click="selectAllApproved" type="button" class="btn-round-red" style="margin-top:0;">
                            Select All Approved
                        </button>
                    </div>

                    <div class="bulkItem" v-if="hasChildrenApproved">
                        <button
                            @click="triggerBulkAction('bulkErp', 'e')"
                            type="button"
                            class="btn-round-green"
                            style="margin-top:0;"
                        >
                            Approve ERP
                        </button>
                    </div>

                    <div class="bulkItem" v-if="executingAction">
                        <vue-loaders-ball-beat scale="1" color="black" />
                    </div>
                </div>
            </div>
        </div>
        <priceworkflow-export-modal
            v-if="showExportModal"
            :pp-id="exportSubmissionId"
            @close="closeExportModal"
            @confirm="confirmExport"
        />
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            activity: "",
            billTo: "",
            company: "",
            createdAt: "",
            createdBy: "",
            executingAction: false,
            priceAuth: "",
            selectedChildIds: [],
            submission: {},
            submittedAt: "",
            showExportModal: false,
            exportSubmissionId: null,
        }
    },
    props: ['parentId'],
    created() {
        this.getSubmission();
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceDeviationAdmins: state => state.priceDeviationAdmins,
            priceERPAdmins: state => state.priceERPAdmins,
        }),
        displayFamilyBulkColumn() {
            return this.hasChildrenInProgress || this.hasChildrenApproved;
        },
        eligibleInProgressChildren() {
            const children = this.submission.child_submissions || [];

            return children.filter(child =>
                child.pp_status === 'p' && this.findIfApprover(child)
            );
        },
        eligibleApprovedChildren() {
            const children = this.submission.child_submissions || [];

            return children.filter(child =>
                child.pp_status === 'a' && this.priceERPAdmins.includes(this.user.id)
            );
        },
        eligibleBulkChildren() {
            return [
                ...this.eligibleInProgressChildren,
                ...this.eligibleApprovedChildren
            ];
        },
        hasChildrenInProgress() {
            return this.eligibleInProgressChildren.length > 0;
        },
        hasChildrenApproved() {
            return this.eligibleApprovedChildren.length > 0;
        },
        allEligibleChildrenSelected() {
            const eligibleIds = this.eligibleBulkChildren.map(child => child.id);

            if (eligibleIds.length === 0) {
                return false;
            }

            return eligibleIds.every(id => this.selectedChildIds.includes(id));
        },
        selectedChildren() {
            const children = this.submission.child_submissions || [];

            return children.filter(child =>
                this.selectedChildIds.includes(child.id)
            );
        },

        selectedInProgressChildren() {
            return this.selectedChildren.filter(child => child.pp_status === 'p');
        },

        selectedApprovedChildren() {
            return this.selectedChildren.filter(child => child.pp_status === 'a');
        },
    },
    methods: {
        getSubmission() {
            axios.get(`/api/getSubmission/${this.parentId}`).then(response => {
                this.submission = response.data;

                this.activity = this.submission.activity.activity;
                this.billTo = this.submission.cust_id;
                this.company = this.submission.company;
                this.createdBy = this.submission.created_by_user.full_name;
                this.priceAuth = this.submission.price_auth;

                this.createdAt = this.formatDate(this.submission.timestamp);
                this.submittedAt = this.formatDate(this.submission.wf_timestamp);

                this.loadingBulkAction = false;
                this.selectedChildIds = [];
            });
        },
        formatDate(dateStr) {
            if (!dateStr || dateStr.length < 8) return "";

            const year = dateStr.substring(0, 4);
            const month = dateStr.substring(4, 6);
            const day = dateStr.substring(6, 8);

            return `${month}/${day}/${year}`;
        },
        toggleSelectAll(event) {
            if (event.target.checked) {
                this.selectedChildIds = this.eligibleBulkChildren.map(child => child.id);
            } else {
                this.selectedChildIds = [];
            }
        },

        selectAllInProgress() {
            this.selectedChildIds = this.eligibleInProgressChildren.map(child => child.id);
        },

        selectAllApproved() {
            this.selectedChildIds = this.eligibleApprovedChildren.map(child => child.id);
        },
        canChildCheckboxBeEnabled(childSubmission) {
            if (childSubmission.pp_status === 'a' && this.priceERPAdmins.includes(this.user.id)) {
                return true;
            }

            if (childSubmission.pp_status === 'p' && this.findIfApprover(childSubmission)) {
                return true;
            }

            return false;
        },
        findIfApprover(childSubmission) {
            if(this.priceDeviationAdmins.includes(this.user.id)) {
                return true;
            } else if (childSubmission.currentSignOffId == this.user.id || 
                (childSubmission.futureSignOffUserIds.length > 0 && childSubmission.futureSignOffUserIds.includes(this.user.id.toString()))) {
                    return true;
            }

            return false;
        },
        submitEntry(ppId) {
            this.loadingBulkAction = true;
            axios.post(`/api/submitEntry`, {ppId: ppId}).then(() => {
                this.getSubmission();
                this.executingAction = false;
            });
        },
        deleteEntry(ppId, type) {
            this.executingAction = true;
            axios.post(`/api/deleteSubmission`, {ppId: ppId}).then(response => {
                if(type === 'family') {
                    this.$router.push({
                        name: "PriceWorkflowDashboards",
                        params: {dashboard: "PriceDeviation"}
                    });
                } else {
                    this.getSubmission();
                }
                this.executingAction = false;
            });
        },
        performBulkAction({action, signOffStatus, submissionIds, userId}) {
            this.executingAction = true;
            let data = {
                action: action,
                signOffStatus: signOffStatus,
                submissionIds: submissionIds,
                userId: userId
            }
            
            axios.post(`/api/performBulkAction`, data).then(response=> {
                this.getSubmission();
                this.executingAction = false;
            });
        },
        validateBulkAction(action) {
            if (this.selectedChildIds.length === 0) {
                alert("Please select at least one child submission first.");
                return false;
            }

            if (action === 'bulkApprove') {
                const hasNonInProgressSelections = this.selectedChildren.some(child => child.pp_status !== 'p');

                if (hasNonInProgressSelections) {
                    alert("Only In Progress child submissions can be bulk approved. Please adjust your selection.");
                    return false;
                }

                return true;
            }

            if (action === 'bulkErp') {
                const hasNonApprovedSelections = this.selectedChildren.some(child => child.pp_status !== 'a');

                if (hasNonApprovedSelections) {
                    alert("Only Approved child submissions can be sent to ERP. Please adjust your selection.");
                    return false;
                }

                return true;
            }

            return true;
        },
        triggerBulkAction(action, signOffStatus) {
            if (!this.validateBulkAction(action)) {
                return;
            }

            this.performBulkAction({
                action: action,
                signOffStatus: signOffStatus,
                submissionIds: this.selectedChildIds,
                userId: this.user.id
            });
        },
        async exportPricingSubmission(ppId, options = {}) {
            this.executingAction = true;
            try {
                const response = await axios.post(
                    `/api/exportPricingSubmission`,
                    {
                        ppId: ppId,
                        includeCustomItems: options.includeCustomItems || false,
                        includeServiceItems: options.includeServiceItems || false,
                    },
                    { responseType: 'blob' }
                );

                let timestamp = new Date().toISOString().replace(/[:.-]/g, '');
                let fileName = `PIP-Retail-Pricing-Deviation-Export-${timestamp}.csv`;

                const disposition = response.headers['content-disposition'];
                if (disposition) {
                    const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = fileNameMatch[1];
                    }
                }

                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream'
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('Export failed:', error);
                alert('There was an issue exporting this submission.');
            } finally {
                this.executingAction = false;
            }
        },
        openExportModal(ppId) {
            this.exportSubmissionId = ppId;
            this.showExportModal = true;
        },
        closeExportModal() {
            this.showExportModal = false;
            this.exportSubmissionId = null;
        },
        confirmExport(options) {
            this.showExportModal = false;

            this.exportPricingSubmission(this.exportSubmissionId, options);

            this.exportSubmissionId = null;
        },
    }
}
</script>

<style scoped>
    #parentInfo ul {
        list-style-type: none;
        padding: 0;
    }

    #parentActions h3 {
        font-family: 'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #childrenDiv {
        margin-top: 20px;
    }

    #childrenTable {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;
    }

    #childrenTable thead th {
        text-align: left;
        padding: 10px 12px;
        background-color: #f5f5f5;
        border-bottom: 2px solid #ddd;
    }

    #childrenTable tbody td {
        padding: 10px 12px;
        border-bottom: 1px solid #eee;
    }

    /* Alternating row backgrounds */
    #childrenTable tbody tr:nth-child(even) {
        background-color: #fafafa;
    }

    #childrenTable tbody tr:nth-child(odd) {
        background-color: #ffffff;
    }

    #childrenTable tbody tr:hover {
        background-color: #f0f7ff;
        transition: background-color 0.15s ease-in-out;
    }

    .iconContainer {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        margin-right: 5px;
    }

    .iconButton {
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
    }

    .iconImg {
        width: 32px;
        height: 32px;
        object-fit: contain;
        display: block;
    }

    .iconLabel {
        margin-top: 6px;
        font-size: 12px;
        text-align: center;
    }

    .iconButton:hover .iconImg {
        opacity: 0.85;
    }

    .iconButton:focus {
        outline: 2px solid #999;
        outline-offset: 2px;
    }

    .iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
    }

    #bulkActionBar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 16px;
    }

    .bulkItem {
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
    }

    /* Left-side text items */
    .bulkTextItem {
        height: 36px;
        line-height: 36px;
        position: relative;
        top: 2px;
    }

    /* Select-all item specifically */
    .bulkSelectItem {
        height: 36px;
        position: relative;
        top: 2px;
    }

    .bulkSelectItem input[type="checkbox"] {
        margin: 0 8px 0 0;
        vertical-align: middle;
    }

    .bulkItem:first-child {
        border-right: 1px solid #ccc;
        padding-right: 12px;
        margin-right: 4px;
    }

    #bulkActionBar button {
        min-width: 160px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }
</style>